import React, {
	useEffect,
	useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CreateOrUpdateMeeting, LoadEventsMeetingByUUID } from '../connection/meeting';
import { GreenroomState } from '../stores/types/types';
import { APP } from '../stores/session-status';
import RedirectSplash from './redirect/redirect-splash';

export default function CreateGreenroomFromStreamsSession() {
	const { sessionId } = useParams();
	const [event, setEvent] = useState(null);
	const [error, setError] = useState('');

	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);

	const createOrUpdateGreenroom = async (greenroom: any) => {
		const result = await CreateOrUpdateMeeting(
			token || 'n/a',
			greenroom.uuid,
			greenroom,
			APP.EVENTS,
			greenroom.standalone_title,
			undefined,
			undefined,
			undefined,
			greenroom.meeting_id,
		);
		if (!result?.meetingId) {
			setError('There has been an error please refresh the page you came from and try the link again.');
		} else {
			window.location.href = `/producer/${result.meetingId}`;
		}
	};

	const loadSession = async () => {
		if (token && sessionId) {
			const data = await LoadEventsMeetingByUUID(token, sessionId);
			setEvent(data);
		}
	};

	useEffect(() => {
		if (!event) {
			loadSession()
				.catch(console.error);
		} else {
			createOrUpdateGreenroom(event)
				.catch(console.error);
		}
	}, [event]);

	return (
		<RedirectSplash hasFailure={!!error} description={error} />
	);
}
